import React, { useEffect, useState, useRef } from 'react';
import { message } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import CardWarp from '@/components/card-warp';
import FullScreen from '@/common/utils/browser/full-screen';
import SalePlaySelectCards from '../strategy-item';
import apis from '../../../../material-play/api';
import ActivityPlanCard from '../marketing-activity';
import { PlanActivityItem } from '../marketing-activity';
import { strategyItem } from '../index';
import { ActivityVersionEnum } from '../interface';

import './index.less';

const prefix = 'all-strategy-0609';

interface StrategyProps {
  onCancel: () => void;
  toSalePlaySelectAndPromotionId: ({ planCode, poolType }: { planCode: string; poolType: string }) => void;
  toSalePlaySelect: (poolType: number, materialType: string) => void;
  planCode: string;
  listinfo: {
    loading: boolean;
    list: strategyItem[];
  };
  toYxPage: (poolId: string | undefined, activityVersion: ActivityVersionEnum, code: string) => void;
  visible?: boolean;
}

const StrategyDom = (props: StrategyProps) => {
  const { onCancel, toSalePlaySelect, toSalePlaySelectAndPromotionId, planCode, listinfo, toYxPage } = props;
  const [activityList, setActivityList] = useState<PlanActivityItem[]>([]);
  const fullRef = useRef(null);

  useEffect(() => {
    apis
      .activityPlanList({
        currentPage: 1,
        pageSize: 50,
      })
      .then((r) => {
        if (r?.data?.list) {
          setActivityList(r.data.list);
        }
        return r;
      })
      .catch((error: unknown) => message.error((error instanceof Error && error.message) || '请求失败'));
  }, []);

  useEffect(() => {
    FullScreen.requestFullscreen(fullRef.current);
  }, []);

  // 选店策略
  const shopList = listinfo?.list?.filter((el) => el.materialType === '5') || [];
  // 商品策略
  const productList = listinfo?.list?.filter((el) => el.materialType === '1') || [];
  // 店铺策略
  const storeList = listinfo?.list?.filter((el) => el.materialType === '7') || [];
  const otherList =
    listinfo?.list?.filter((el) => el.materialType !== '1' && el.materialType !== '5' && el.materialType !== '7') || [];
  const allOtherList = storeList.concat(otherList) || [];
  return (
    <div className={`${prefix}-wrapper`} ref={fullRef}>
      <div className={`${prefix}-top`}>
        <div className={`${prefix}-title`}>
          <h3>通用策略</h3>
          <CloseOutlined onClick={onCancel} />
        </div>
        <div className="line" />
      </div>
      <div className={`${prefix}-content`}>
        <div className="item">
          <div className={`${prefix}-item`}>
            <CardWarp
              title="商品策略"
              extra="商品策略：基于场域运营导向通过规则进行商品策略创建，可从创建后的商品策略中，再通过规则叠加形成可直接关联资源位上场的商品组。"
              isMountParent
            >
              <SalePlaySelectCards
                toSalePlaySelectAndPromotionId={toSalePlaySelectAndPromotionId}
                toSalePlaySelect={toSalePlaySelect}
                planCode={planCode!}
                list={productList}
              />
            </CardWarp>
          </div>
        </div>
        <div className="item">
          <div className={`${prefix}-item`}>
            <CardWarp title="选店策略" isMountParent>
              <SalePlaySelectCards
                toSalePlaySelectAndPromotionId={toSalePlaySelectAndPromotionId}
                toSalePlaySelect={toSalePlaySelect}
                planCode={planCode!}
                list={shopList}
              />
            </CardWarp>
          </div>
        </div>
        <div className="item">
          <CardWarp
            title="其他策略"
            extra="精选店铺底池，内容底池和频道底池等，不区分业务场景。支持各业务按不同运营策略选择不同类型的商品底池，叠加选品规则，生成商品组进行素材关联使用。"
            isMountParent
          >
            <SalePlaySelectCards
              toSalePlaySelectAndPromotionId={toSalePlaySelectAndPromotionId}
              toSalePlaySelect={toSalePlaySelect}
              planCode={planCode!}
              list={allOtherList}
            />
          </CardWarp>
        </div>
        {activityList.length > 0 && (
          <div className="item">
            <CardWarp
              title="营销活动策略"
              extra="有对应权限精选营销活动底池，不区分业务场景。支持各业务按不同运营策略选择不同类型的商品底池，叠加选品规则，生成商品组进行素材关联使用。"
              isMountParent
            >
              <div className={`${prefix}-card-container`}>
                {activityList.map((item) => (
                  <ActivityPlanCard
                    onClick={() => {
                      toYxPage(item.poolId, item.activityVersion, item.planCode);
                    }}
                    {...item}
                    buttonText={'去选品'}
                    key={item.id}
                  />
                ))}
              </div>
            </CardWarp>
          </div>
        )}
      </div>
    </div>
  );
};

export default StrategyDom;
